import { render, staticRenderFns } from "./RemovableList.vue?vue&type=template&id=4120a7c6&scoped=true&"
import script from "./RemovableList.vue?vue&type=script&lang=js&"
export * from "./RemovableList.vue?vue&type=script&lang=js&"
import style0 from "./RemovableList.vue?vue&type=style&index=0&id=4120a7c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120a7c6",
  null
  
)

export default component.exports